/**
 * tdesign v1.5.1
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  allowUncheck: Boolean,
  checked: {
    type: Boolean,
    "default": void 0
  },
  modelValue: {
    type: Boolean,
    "default": void 0
  },
  defaultChecked: Boolean,
  "default": {
    type: [String, Function]
  },
  disabled: {
    type: Boolean,
    "default": void 0
  },
  label: {
    type: [String, Function]
  },
  name: {
    type: String,
    "default": ""
  },
  value: {
    type: [String, Number, Boolean],
    "default": void 0
  },
  onChange: Function,
  onClick: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
